<template>
  <div class="wrapper">
    <div class="container">
      <h2>{{ $route.path }}</h2>
      <h2>Файл не найден</h2>
      <router-link to="/" class="link">Вернуться на сайт</router-link>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  export default defineComponent({
      name: 'NotFoundView'
  })
</script>

<style scoped>

.wrapper {
  height: 100%;
  width: 100%;
  display: grid;
  align-items: center;
  justify-items: center;
}

.container {
  text-align: center;
  line-height: 2rem;
}

.link {
  display: block;
  margin-top: 5rem;
  color: var(--red);
}
</style>